import {
    ILogger,
    Logger,
} from '@services/logger/abstract.logger';

const noop = () => { };

export class ProductionLogger extends Logger {
    /**
    * An internal logger is required to perform multiple operations
    * The class returnes to method references in order to keep the original caller line
    */
    private _logger: ILogger;

    constructor() {
        super();

        this._logger = {
            log: noop,
            warn: noop,
            error: (...params: any[]) => {
                console.error(...params);
            },
        };
    }

    public get log() { return this._logger.log; }

    public get warn() { return this._logger.warn; }

    public get error() { return this._logger.error; }
}
